/**
 * Camada 1 · a barra inferior do celular.
 *
 * ENTROU EM 29/08/2026 para fechar a linha V22 da paridade do prontidao, e o motivo dela e
 * de operacao e nao de estetica: sem barra, no telefone a pessoa abre a gaveta para TODO
 * gesto, e o telefone e onde o trabalho de campo acontece. Uma gaveta a mais por navegacao
 * parece pouco no computador e e o dia inteiro para quem opera de pe, com uma mao so.
 *
 * QUATRO ITENS, NO MAXIMO, e o loader recusa o quinto. O numero nao e arbitrario: em 390px
 * de largura, cinco alvos caem abaixo dos 44px e a barra vira uma fileira de botoes que
 * ninguem acerta. O legado chegou ao mesmo numero, e ate registrou qual item saiu quando
 * `Voar` entrou.
 *
 * SO NO CELULAR, e some do tablet para cima: la o rail ja e coluna no fluxo, e uma barra
 * embaixo seria um segundo caminho para o mesmo lugar. Dois caminhos para a mesma coisa
 * envelhecem em ritmos diferentes, e um deles passa a levar ao lugar errado.
 *
 * PRODUTO QUE NAO DECLARA NENHUM ITEM NAO GANHA BARRA VAZIA. O chassi nao desenha uma faixa
 * ocupando altura no telefone para dizer que nao ha nada nela.
 */

import type { ItemMenu } from '@complexity/product-kit';
import { t } from '@complexity/i18n';
import { icone as resolverIcone } from '@complexity/ui';

export interface BarraInferiorProps {
  /** Os itens que o produto marcou com `naBarraInferior`. Vazio nao desenha nada. */
  readonly itens: readonly ItemMenu[];
  readonly rotaAtiva: string;
  readonly aoNavegar: (rota: string) => void;
}

export function BarraInferior({ itens, rotaAtiva, aoNavegar }: BarraInferiorProps) {
  // Sem item declarado nao ha barra. Retornar null e diferente de desenhar uma faixa vazia:
  // a segunda ocupa altura da tela para nao dizer nada.
  if (itens.length === 0) return null;

  return (
    <nav
      aria-label={t('Acesso rápido')}
      className={[
        // `md:hidden` e a linha inteira do "so no celular". Do tablet para cima o rail ja e
        // coluna no fluxo, e a barra seria um segundo caminho para o mesmo lugar.
        'flex shrink-0 border-t border-borda bg-superficie-elevada md:hidden',
        // `pb-safe` nao existe no preset; o padding de baixo cobre a barra de gestos do
        // telefone, que come os ultimos pixels da tela em aparelho sem botao fisico. Sem
        // isso, o alvo de toque existe e fica embaixo do risco do sistema.
        'pb-[env(safe-area-inset-bottom)]',
      ].join(' ')}
    >
      {itens.map((item) => {
        const ativo = item.rota === rotaAtiva || rotaAtiva.startsWith(`${item.rota}/`);
        const Desenho = resolverIcone(item.icone);
        return (
          <button
            key={item.rota}
            type="button"
            onClick={() => aoNavegar(item.rota)}
            aria-current={ativo ? 'page' : undefined}
            className={[
              // `flex-1` divide a largura em partes iguais: alvo proporcional ao texto faria
              // "Voar" ser um alvo pequeno e "Tripulação" um alvo grande, e o dedo nao le
              // rotulo antes de tocar.
              'flex min-h-toque flex-1 flex-col items-center justify-center gap-0.5 px-cx-1 py-cx-2 text-cx-xs',
              ativo ? 'text-marca' : 'text-texto-suave',
            ].join(' ')}
          >
            {/* Mesmo fallback do rail, e pelo mesmo motivo: nome desconhecido vira um
                PONTO, e nunca o texto cru. O comentario anterior dizia que apagar o texto
                pioraria quem ja usava o chassi, e isso era verdade enquanto faltavam icones
                desenhados para os nomes que os produtos declaravam. Passaram a existir em
                30/08/2026, e o ramo que
                pintava emoji na barra do celular fechou junto. */}
            {Desenho ? (
              <Desenho aria-hidden="true" className="h-5 w-5" />
            ) : (
              <span aria-hidden="true" className="flex h-5 w-5 items-center justify-center">
                <span className="h-1.5 w-1.5 rounded-cx-full bg-texto-fraco" />
              </span>
            )}
            {/* O ROTULO ESCRITO ACOMPANHA SEMPRE, e nao so o icone. Icone sozinho numa barra
                de quatro e adivinhacao, e a pessoa aprende por tentativa, tocando no errado
                primeiro. `truncate` para um rotulo longo nao quebrar a linha e empurrar a
                altura da barra inteira. */}
            <span className="w-full truncate text-center leading-tight">{t(item.label)}</span>
          </button>
        );
      })}
    </nav>
  );
}
